/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import Select, { createFilter } from "react-select";
import SelectAsync from "react-select/async";
import {
	formatCurrency,
	formatNumber,
	isVendedor,
	money,
} from "../../../../utils/helpers";
import PropTypes from "prop-types";

import ItemFotos from "../../../Items/ItemFotos";
import Modal from "../../../general/Modal";
import useProducto from "../hooks/useProducto";
import { opcionesUnidades, aCantidadBase } from "../../../../utils/unidades";

// TODO: hay que guardar el impuesto y el descuento de producto

const ProductosFactura = ({
	producto,
    productos,
	updateTotal,
	index,
	removeProducto,
	precioLimite,
	banderaContacto,
	impuestosForDropdown,
	facturaProductos,
	isEdit,
    isRecovery,
    fromPlantilla,
	errors,
	contacto
}) => {
    const {
        productoInfo,
        productLabel,
        getProductos,
        total,
        totalReal,
        preciosVenta,
        precioManual,
        pinSeguridad,
        productoITBIS,
        checkQuantityConstrains,
        checkPINSeguridad,
        onChangeInput,
        onChangeImpuestoManual,
        onChangeProducto,
        onChangeCostoManual,
        onChangeUnidad,
        handlePrecioVentaChange,
        setProductoInfo,
        setPrecioManual,
        setPinSeguridad,
        setShowFotos,
        toggleFotosModal,
        toggleDeleteModal,
        togglePINModal,
        showPrecioManual,
        showFotos,
        showDelete,
        showPINModal,
        volverAlSelector
    } = useProducto(producto, facturaProductos, updateTotal, index, impuestosForDropdown, banderaContacto, precioLimite, contacto, isEdit, isRecovery, fromPlantilla);

	return (
		<>
			<tr>
				<td colSpan={2}>
					<input
						type="hidden"
						name={`productos[${index}][id]`}
						value={producto?.id ? producto.id : `random-${index}`}
					/>

					<SelectAsync
                        key={`productos[${index}]`}
						name={`productos[${index}][producto_id]`}
						placeholder={"Buscar..."}
                        defaultOptions={
							productos && contacto &&
							productos.map((producto) => ({
								label: `${producto.referencia} ${producto.nombre}`,
								value: producto.id,
								producto: producto,
							}))
						}
                        noOptionsMessage={(query) => query?.inputValue.length > 0 ? `No se encontraron productos para "${query?.inputValue}"` : "Seleccione un cliente para empezar."}
                        loadingMessage={() => "Cargando..."}
                        loadOptions={(e) => getProductos("productos?limit=50&buscar="+e)}
						value={
							productoInfo.id && {
								value: productoInfo.id,
								label: productoInfo.nombre,
							}
						}
						onChange={(e) => onChangeProducto(e.value, e.producto)}
						styles={{
							singleValue: (provided, state) => ({
								...provided,
								width: "100%",
								display: "flex",
							}),
							menu: (provided, state) => ({
								...provided,
								width: "150%",
							}),
							option: (provided, state) => ({
								...provided,
								backgroundColor: state.isSelected
									? "rgba(152, 204, 245,.3)"
									: "white",
								color: state.isSelected ? "#008aab" : "#666666",
								fontWeight: state.isSelected ? "600" : "normal",
							}),
						}}
						maxMenuHeight={200}
						formatOptionLabel={(option) =>
							option.producto
								? productLabel(option.producto)
								: option.label
						}
					/>
                    {productoInfo?.producto?.tipo === 'grupo' && (
                        <ul style={{padding: "10px 25px 0", margin: 0, lineHeight: 1.2, fontSize: "0.8rem"}}>
                            {productoInfo?.producto?.componentes?.map(item => (<li key={item.id}>{item.componente?.referencia} - {item.componente?.nombre} - Cant: {item.cantidad}</li>))}
                        </ul>
                    )}
				</td>
				<td>
					<input
						type="number"
						name={`productos[${index}][cantidad]`}
						placeholder="Cantidad"
						value={productoInfo.cantidad || ''}
						step="1"
						min="1"
						onChange={(e) => {
							producto.cantidad = parseFloat(
                                e.target.value || 0
                            );
							onChangeInput("cantidad", e.target.value);
						}}
						onBlur={() => checkQuantityConstrains()}
						className="form-control"
					/>
				</td>
				<td style={{ width: "150px" }}>
					<input type="hidden" name={`productos[${index}][unidad]`} value={productoInfo.unidadSeleccionada?.value ?? productoInfo.unidad ?? ""} />
					<input type="hidden" name={`productos[${index}][factor]`} value={productoInfo.factor ?? 1} />
					<input type="hidden" name={`productos[${index}][cantidad_base]`} value={aCantidadBase(productoInfo.cantidad, productoInfo.factor ?? 1)} />
					<input type="hidden" name={`productos[${index}][unidad_id]`} value={productoInfo.unidadSeleccionada?.unidad_id ?? ""} />
					<Select
						placeholder="Und."
						options={opcionesUnidades({ unidades: productoInfo.unidades })}
						value={
							productoInfo.unidadSeleccionada
								? {
										...productoInfo.unidadSeleccionada,
										label: productoInfo.factor > 1
											? `${productoInfo.unidadSeleccionada.value} (x${productoInfo.factor})`
											: productoInfo.unidadSeleccionada.value,
								  }
								: null
						}
						onChange={(opcion) => onChangeUnidad(opcion)}
						isDisabled={(productoInfo.unidades?.length ?? 0) <= 1}
						menuPortalTarget={document.body}
						styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
					/>
				</td>
				<td>
					<input
						type="text"
						style={{ backgroundColor: "#fff" }}
						value={formatCurrency(money(productoInfo?.costo))}
						className="form-control"
						readOnly
					/>
					<input
						type="hidden"
						name={`productos[${index}][importe]`}
						className="form-control"
						value={productoInfo.costo}
						readOnly
					/>
				</td>
				<td>
                    {showPrecioManual ? (
                        <Select
                            placeholder="Impuesto"
                            options={impuestosForDropdown}
                            value={productoInfo.impuesto?.value ? productoInfo.impuesto : null}
                            onChange={(e) => onChangeImpuestoManual(e.value)}
                            menuPortalTarget={document.body}
                            styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                        />
                    ) : (
                        <input
                            className="form-control"
                            value={productoInfo.impuesto?.label}
                            readOnly
                        />
                    )}

                    <input
                        type="hidden"
                        name={`productos[${index}][impuesto_id]`}
                        value={productoInfo.impuesto?.value || productoInfo.producto?.impuesto?.id}
                    />
				</td>
				<td>
					{!showPrecioManual ? (
						<Select
							type="text"
							name={`productos[${index}][costo]`}
							placeholder={"Seleccione..."}
							loadingMessage={() => "Cargando"}
							onChange={(e) => handlePrecioVentaChange(e)}
							maxMenuHeight={200}
							options={
								[
									...preciosVenta(),
									{ value: "manual", label: "Manual" },
								] || []
							}
							value={productoInfo?.precio_venta || {}}
						/>
					) : (
						<input
							type="number"
							className="form-control"
							name={`productos[${index}][costo]`}
							value={precioManual}
                            id={`costo-${index}`}
							onChange={(e) => {
                                const svalue = e.target.value;
                                setPrecioManual(svalue)
                                setProductoInfo(prev => {
                                    return {
                                        ...prev,
                                        precio_manual: svalue
                                    }
                                })
                                onChangeCostoManual(svalue, false, productoInfo)
                            }}
							onBlur={(e) => {
                                onChangeCostoManual(e.target.value, true, productoInfo)
                            }}
							onDoubleClick={() => {
                                volverAlSelector();
                            }}
						/>
					)}
				</td>
				<td>
                    <input type="hidden" name={`productos[${index}][descuento]`} value="0" />
					<input
						type="number"
						min="0"
						name={`productos[${index}][descuento]`}
						placeholder="Descuento"
						value={productoInfo.descuento}
						step="0.1"
						onChange={(e) =>
							onChangeInput("descuento", e.target.value)
						}
						className="form-control"
					/>
				</td>
				<td className="text-right">
					{!showPrecioManual ? (
						<input
							type="hidden"
							name={`productos[${index}][precio_facturado]`}
							value={total / productoInfo.cantidad}
						/>
					) : (
						<input
							type="hidden"
							name={`productos[${index}][precio_facturado]`}
							value={precioManual}
						/>
					)}

					<input
						type="hidden"
						name={`productos[${index}][total]`}
						value={total}
					/>
					{formatCurrency(productoInfo.descuento > 0 ? totalReal : total)}
				</td>
				<td className="text-center">
					{productoInfo.fotos?.length > 0 && (
						<button
							type="button"
							title="Ver Fotos"
							onClick={() => toggleFotosModal()}
							className="producto"
						>
							<i className="fas fa-eye"></i>
						</button>
					)}
				</td>
				<td className="text-right">
					<button
						type="button"
						className="btn btn-danger"
						onClick={() =>
							(isEdit || fromPlantilla) && productoInfo.nombre
								? toggleDeleteModal()
								: removeProducto(producto.id)
						}
					>
						<i className="fas fa-trash"></i>
					</button>
				</td>
			</tr>
            {errors[`productos.${index}.producto_id`] && (
				<small
					className="help-blockParams form-Text d-block"
					style={{ whiteSpace: "nowrap" }}
				>
					Este producto está {errors[`productos.${index}.producto_id`][0]}
				</small>
			)}
			{errors[`productos.${index}.total`] && (
				<small
					className="help-blockParams form-Text d-block"
					style={{ whiteSpace: "nowrap" }}
				>
					{errors[`productos.${index}.total`][0]}
				</small>
			)}
			{errors[`productos.${index}.cantidad`] && (
				<small
					className="help-blockParams form-Text d-block"
					style={{ whiteSpace: "nowrap" }}
				>
					{errors[`productos.${index}.cantidad`][0]}
				</small>
			)}
			{productoInfo?.fotos && (
				<Modal
					show={showFotos}
					blank={true}
					toggle={() => setShowFotos((state) => !state)}
				>
					<ItemFotos
						toggle={() => setShowFotos((state) => !state)}
						fotos={productoInfo.fotos}
					/>
				</Modal>
			)}
			<Modal
				title="Borrar Producto"
				show={showDelete}
				callback={() => removeProducto(producto.id)}
				acceptText="Borrar"
				toggle={toggleDeleteModal}
			>
				¿Estás seguro de que deseas borrar este producto?
                <div className="alert alert-warning mt-3">{productoInfo.nombre}</div>
			</Modal>
			{/* <---PIN DE SEGURIDAD MODAL--- */}
			<Modal
				title="PIN de seguridad"
				show={showPINModal}
				callback={() => checkPINSeguridad()}
				acceptText="Aceptar"
				toggle={() => {
                    const event = new CustomEvent('pinCancelado');
                    window.dispatchEvent(event);
                }}
				size="419px"
			>
				<div className="form-group">
					<label>PIN de seguridad</label>
					<input
						type="password"
						className="form-control"
						name="pin_seguridad"
						value={pinSeguridad}
						onChange={(e) => setPinSeguridad(e.target.value)}
					/>
					<p
						className="font-weight-bold"
						style={{
							color: "gray",
							fontStyle: "italic",
							lineHeight: "13px",
							fontSize: "0.7rem",
						}}
					>
						Para continuar ingrese PIN de seguridad
					</p>
				</div>
			</Modal>
		</>
	);
};

ProductosFactura.propTypes = {
	producto: PropTypes.object,
	updateTotal: PropTypes.func,
	productos: PropTypes.array,
	index: PropTypes.number,
	removeProducto: PropTypes.func,
	precioLimite: PropTypes.number,
	impuestosForDropdown: PropTypes.array,
	facturaProductos: PropTypes.array,
	isEdit: PropTypes.bool,
	isRecovery: PropTypes.bool,
};

export default ProductosFactura;
